import { useFindAllContactSentimentsByChatIdQuery } from 'services';
import { FindAllContactSentimentsByChatDto, FindAllContactSentimentsDto } from 'types';

export const useFindAllContactSentimentsByChat = (data?: FindAllContactSentimentsByChatDto, options?: any) => {
  const {
    data: contactSentiments,
    isLoading: isLoadingContactSentiments,
    isFetching: isFetchingContactSentiments,
    refetch: refetchContactSentiments
  } = useFindAllContactSentimentsByChatIdQuery(data!, {
    refetchOnMountOrArgChange: true,
    skip: !data?.chatIds || data.chatIds.length === 0,
    ...options
  });

  return {
    contactSentiments: contactSentiments?.data?.rows,
    isLoadingContactSentiments,
    isFetchingContactSentiments,
    refetchContactSentiments
  };
};
